module.exports = __webpack_public_path__ + "shareIcon.f750656c.png";